import { httpClient } from '@configs/httpclient.config';
import { AxiosResponse } from 'axios';

export const ATTACHMENT_URL = '/moex-datashop-attachmentservice/api/file-service/v1';

export const downloadFile = (bucket: string, ticket: string): Promise<AxiosResponse<Blob>> =>
    httpClient.get(ATTACHMENT_URL + `/download/${bucket}/${ticket}`, {
        responseType: 'blob',
    });
